<script lang="ts">
	import "../assets/css/ckeditor.css";
	import { transformCkEditorContent } from "../utils/transformCkEditorContent.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";

	export let content: string;
	export let keepParagraphSize = false;

	const { STORAGE_URL } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html transformCkEditorContent(content, {
	storageUrl: STORAGE_URL,
	keepParagraphSize,
})}
